var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-callback"},[_c('b-spinner',{attrs:{"label":"Signing in..."}}),_c('p',{staticClass:"auth-callback--text"},[_vm._v("Signing in...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }